import { render, staticRenderFns } from "./VNet.vue?vue&type=template&id=0e466f5c&"
import script from "./VNet.vue?vue&type=script&lang=js&"
export * from "./VNet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports